module.exports = __webpack_public_path__ + "static/media/startseite.69328239.jpg";